import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/diagnosis',
    name: 'PublicDiagnosis',
    component: () => import('../views/Diagnosis.vue')
  },
  // 学生端路由
  {
    path: '/student/login',
    name: 'StudentLogin',
    component: () => import('../views/student/Login.vue')
  },
  {
    path: '/student/register',
    name: 'StudentRegister',
    component: () => import('../views/student/Register.vue')
  },
  {
    path: '/student/dashboard',
    name: 'StudentDashboard',
    component: () => import('../views/student/Dashboard.vue'),
    meta: { requiresAuth: true, role: 'student' }
  },
  {
    path: '/student/plans',
    name: 'StudentPlans',
    component: () => import('../views/student/Plans.vue'),
    meta: { requiresAuth: true, role: 'student' }
  },
  {
    path: '/student/plans/:id',
    name: 'PlanDetail',
    component: () => import('../views/student/PlanDetail.vue'),
    meta: { requiresAuth: true, role: 'student' }
  },
  {
    path: '/student/checkin',
    name: 'StudentCheckin',
    component: () => import('../views/student/Checkin.vue'),
    meta: { requiresAuth: true, role: 'student' }
  },
  {
    path: '/student/form',
    name: 'StudentForm',
    component: () => import('../views/student/Form.vue'),
    meta: { requiresAuth: true, role: 'student' }
  },
  {
    path: '/student/stats',
    name: 'StudentStats',
    redirect: '/student/all-plans',
    meta: { requiresAuth: true, role: 'student' }
  },
  {
    path: '/student/all-plans',
    name: 'StudentAllPlans',
    component: () => import('../views/student/AllPlans.vue'),
    meta: { requiresAuth: true, role: 'student' }
  },
  {
    path: '/student/review/:taskId',
    name: 'ReviewDetail',
    component: () => import('../views/student/ReviewDetail.vue'),
    meta: { requiresAuth: true, role: 'student' }
  },
  {
    path: '/student/profile',
    name: 'StudentProfile',
    component: () => import('../views/student/Profile.vue'),
    meta: { requiresAuth: true, role: 'student' }
  },
  {
    path: '/student/ai-tutor',
    name: 'AiTutor',
    component: () => import('../views/student/AiTutor.vue'),
    meta: { requiresAuth: true, role: 'student' }
  },
  {
    path: '/student/notes',
    name: 'StudyNotes',
    component: () => import('../views/student/StudyNotes.vue'),
    meta: { requiresAuth: true, role: 'student' }
  },
  {
    path: '/student/mistakes',
    name: 'Mistakes',
    component: () => import('../views/student/Mistakes.vue'),
    meta: { requiresAuth: true, role: 'student' }
  },
  // 教师端路由
  {
    path: '/teacher/login',
    name: 'TeacherLogin',
    component: () => import('../views/teacher/Login.vue')
  },
  {
    path: '/teacher/dashboard',
    name: 'TeacherDashboard',
    component: () => import('../views/teacher/Dashboard.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/students',
    name: 'TeacherStudents',
    component: () => import('../views/teacher/Students.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/plans',
    name: 'TeacherPlans',
    component: () => import('../views/teacher/Plans.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/plans/:id',
    name: 'TeacherPlanDetail',
    component: () => import('../views/teacher/PlanDetailEdit.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/checkins',
    name: 'TeacherCheckins',
    component: () => import('../views/teacher/Checkins.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
    {
      path: '/teacher/data-maintenance',
      name: 'DataMaintenance',
      component: () => import('../views/teacher/DataMaintenance.vue'),
      meta: { title: '课程数据维护', requiresAuth: true, role: 'teacher' }
    },
    {
      path: '/teacher/question-bank-maintenance',
      name: 'QuestionBankMaintenance',
      component: () => import('../views/teacher/QuestionBankMaintenance.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/forms',
    name: 'TeacherForms',
    component: () => import('../views/teacher/Forms.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/forms/:id',
    name: 'TeacherFormEdit',
    component: () => import('../views/teacher/FormEdit.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/students/:studentId/exam',
    name: 'ExamGenerator',
    component: () => import('../views/teacher/ExamGenerator.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/students/:studentId/all-plans',
    name: 'TeacherStudentAllPlans',
    component: () => import('../views/teacher/StudentAllPlans.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/follow-up',
    name: 'TeacherFollowUp',
    component: () => import('../views/teacher/FollowUp.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/conversion-workbench',
    name: 'TeacherConversionWorkbench',
    component: () => import('../views/teacher/ConversionWorkbench.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/daily-scripts',
    name: 'TeacherDailyScripts',
    component: () => import('../views/teacher/DailyScripts.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/diagnosis-leads',
    name: 'TeacherDiagnosisLeads',
    component: () => import('../views/teacher/DiagnosisLeads.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  },
  {
    path: '/teacher/forms/:id/submissions',
    name: 'TeacherFormSubmissions',
    component: () => import('../views/teacher/FormSubmissions.vue'),
    meta: { requiresAuth: true, role: 'teacher' }
  }
  // 长难句打卡系统路由（已移至 长难句/ 文件夹，需要集成时取消注释）
  // {
  //   path: '/sentences',
  //   name: 'SentenceHome',
  //   component: () => import('../views/sentences/Home.vue')
  // },
  // {
  //   path: '/sentences/profile',
  //   name: 'SentenceProfile',
  //   component: () => import('../views/sentences/Profile.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const user = store.state.user
  
  // 检查是否需要认证
  if (to.meta.requiresAuth) {
    if (!token) {
      // 未登录，跳转到登录页
      if (to.meta.role === 'student') {
        next('/student/login')
      } else if (to.meta.role === 'teacher') {
        next('/teacher/login') // TODO: 创建教师登录页
      } else {
        next('/student/login')
      }
      return
    }
    
    // 检查角色权限
    if (to.meta.role && user && user.role !== to.meta.role) {
      // 角色不匹配，跳转到对应角色的首页
      if (user.role === 'student') {
        next('/student/dashboard')
      } else if (user.role === 'teacher') {
        next('/teacher/dashboard') // TODO: 创建教师首页
      } else {
        next('/')
      }
      return
    }
  }
  
    // 已登录用户访问登录页，跳转到对应首页
    if ((to.path === '/student/login' || to.path === '/student/register') && token) {
      if (user && user.role === 'student') {
        next('/student/dashboard')
        return
      }
    }
    
    if (to.path === '/teacher/login' && token) {
      if (user && user.role === 'teacher') {
        next('/teacher/dashboard')
        return
      }
    }

  next()
})

export default router
